import audio1 from 'assets/sounds/adult/ordiktatSounds/no/1-godt.mp3';
import audio2 from 'assets/sounds/adult/ordiktatSounds/no/2-aldri.mp3';
import audio3 from 'assets/sounds/adult/ordiktatSounds/no/3-kanskje.mp3';
import audio4 from 'assets/sounds/adult/ordiktatSounds/no/4-vrt.mp3';
import audio5 from 'assets/sounds/adult/ordiktatSounds/no/5-fullt.mp3';
import audio6 from 'assets/sounds/adult/ordiktatSounds/no/6-love.mp3';
import audio7 from 'assets/sounds/adult/ordiktatSounds/no/7-vrt.mp3';
import audio8 from 'assets/sounds/adult/ordiktatSounds/no/8-trygt.mp3';
import audio9 from 'assets/sounds/adult/ordiktatSounds/no/9-fullt.mp3';
import audio10 from 'assets/sounds/adult/ordiktatSounds/no/10-sjelden.mp3';
import audio11 from 'assets/sounds/adult/ordiktatSounds/no/11-ungdomsskole.mp3';
import audio12 from 'assets/sounds/adult/ordiktatSounds/no/12-adresse.mp3';
import audio13 from 'assets/sounds/adult/ordiktatSounds/no/13-kirurgi.mp3';
import audio14 from 'assets/sounds/adult/ordiktatSounds/no/14-vert.mp3';
import audio15 from 'assets/sounds/adult/ordiktatSounds/no/15-bnner.mp3';
import audio16 from 'assets/sounds/adult/ordiktatSounds/no/16-aggressiv.mp3';
import audio17 from 'assets/sounds/adult/ordiktatSounds/no/17-konkurranse.mp3';
import audio18 from 'assets/sounds/adult/ordiktatSounds/no/18-selvsagt.mp3';
import audio19 from 'assets/sounds/adult/ordiktatSounds/no/19-rettssak.mp3';
import audio20 from 'assets/sounds/adult/ordiktatSounds/no/20-dessverre.mp3';
import audio21 from 'assets/sounds/adult/ordiktatSounds/no/21-herlig.mp3';
import audio22 from 'assets/sounds/adult/ordiktatSounds/no/22-elleve.mp3';
import audio23 from 'assets/sounds/adult/ordiktatSounds/no/23-skylle.mp3';
import audio24 from 'assets/sounds/adult/ordiktatSounds/no/24-lave.mp3';
import audio25 from 'assets/sounds/adult/ordiktatSounds/no/25-meteorolog.mp3';
import audio26 from 'assets/sounds/adult/ordiktatSounds/no/26-nysgjerrig.mp3';
import audio27 from 'assets/sounds/adult/ordiktatSounds/no/27-skylde.mp3';
import audio28 from 'assets/sounds/adult/ordiktatSounds/no/28-skikkelig.mp3';
import audio29 from 'assets/sounds/adult/ordiktatSounds/no/29-verdt.mp3';
import audio30 from 'assets/sounds/adult/ordiktatSounds/no/30-hrverk.mp3';
import audio31 from 'assets/sounds/adult/ordiktatSounds/no/31-arrangement.mp3';
import audio32 from 'assets/sounds/adult/ordiktatSounds/no/32-bnder.mp3';
import audio33 from 'assets/sounds/adult/ordiktatSounds/no/33-giftige.mp3';
import audio34 from 'assets/sounds/adult/ordiktatSounds/no/34-transporttjenester.mp3';
import audio35 from 'assets/sounds/adult/ordiktatSounds/no/35-brekraftstrategi.mp3';

const audioFiles = {
	1: audio1,
	2: audio2,
	3: audio3,
	4: audio4,
	5: audio5,
	6: audio6,
	7: audio7,
	8: audio8,
	9: audio9,
	10: audio10,
	11: audio11,
	12: audio12,
	13: audio13,
	14: audio14,
	15: audio15,
	16: audio16,
	17: audio17,
	18: audio18,
	19: audio19,
	20: audio20,
	21: audio21,
	22: audio22,
	23: audio23,
	24: audio24,
	25: audio25,
	26: audio26,
	27: audio27,
	28: audio28,
	29: audio29,
	30: audio30,
	31: audio31,
	32: audio32,
	33: audio33,
	34: audio34,
	35: audio35,
};

export default audioFiles;
